import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SantaTooltipModule } from '@alliance/santa/tooltip'
import { SantaInlineTooltipModule } from '@alliance/santa/inline-tooltip'
import { StaticInlineTooltipComponent } from './static-inline-tooltip/static-inline-tooltip.component'
import { StaticDirectiveTooltipComponent } from './static-directive-tooltip/static-directive-tooltip.component'
import { ApplyStaticTooltipActionDirective } from './apply-static-tooltip-action.directive'
import { SharedWebApisIntersectionObserverModule } from '@alliance/cdk/viewport'

@NgModule({
  imports: [CommonModule, SantaTooltipModule, SantaInlineTooltipModule, SharedWebApisIntersectionObserverModule],
  declarations: [StaticDirectiveTooltipComponent, StaticInlineTooltipComponent, ApplyStaticTooltipActionDirective],
  exports: [StaticDirectiveTooltipComponent, StaticInlineTooltipComponent, ApplyStaticTooltipActionDirective]
})
export class AtsUiStaticTooltipModule {}
